import { useState } from "react";
import { Api } from "../api/Api";
import {useErrorWebhook} from "./useErrorWebhook";

export const usePreviewData = () => {
  const { ErrorWebhookTrigger } = useErrorWebhook();

  const savePreviewData= async (
    uuid
  ) => {
    const response = await Api.post("api/v1/get-preview-data", {
      uuid
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'PREVIEW DATA',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
  });
    return response;
  };

  const getMeritPagePreviewData = async (uuid) => {
    const response = await Api.post("api/v1/get-merit-page-data",{uuid})
    .catch(function (error) {
      const erroMessage = {
        serviceName : 'MERIT PAGE DATA',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
  });
    return response;
  };

  const getMeritPageDataOverdraft = async (uuid) => {
    const response = await Api.post("api/v1/get-merit-page-data-overdraft",{uuid})
    .catch(function (error) {
      const erroMessage = {
        serviceName : 'MERIT PAGE DATA',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
  });
    return response;
  };
  const getMeritPageDataUFCV2 = async (uuid) => {
    const response = await Api.post("api/v1/get-merit-page-data-UFCV2",{uuid})
    .catch(function (error) {
      const erroMessage = {
        serviceName : 'MERIT PAGE DATA',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
  });
    return response;
  };

  const getChDocPreviewData = async (uuid) => {
    const response = await Api.post("api/v1/get-ch-doc-preview-data-OD",{uuid})
    .catch(function (error) {
      const erroMessage = {
        serviceName : 'CH PREVIEW PAGE DATA',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
  });
  return response;
  };

  const getPreviewDataReEngaged= async (
    uuid,
    reEngagedId
  ) => {
    const response = await Api.post("api/v1/get-preview-data-re_engaged", {
      uuid,
      reEngagedId
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'PREVIEW DATA',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
  });
    return response;
  };

  return { savePreviewData, getMeritPagePreviewData, getMeritPageDataOverdraft ,getMeritPageDataUFCV2, getChDocPreviewData, getPreviewDataReEngaged};
};
